import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  // linkActiveClass: 'is-active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      name: 'Login',
      path: '/login',
      component: Vue.component('login', require('./components/Login/index.vue')),
      meta: { requiresAuth: false }
    },
    {
      name: 'Coches',
      path: '/',
      component: Vue.component('coach', require('./components/Coach/index.vue')),
      meta: { requiresAuth: true }
    },
    {
      name: 'Utilizadores',
      path: '/users',
      component: Vue.component('user', require('./components/User/index.vue')),
      meta: { requiresAuth: true }
    },
    {
      name: 'Coche',
      path: '/:id',
      component: Vue.component('coach', require('./components/Coach/Coach.vue')),
      meta: { requiresAuth: true }
    },
    {
      name: 'Menu',
      path: '/:id/menu/:cat',
      component: Vue.component('slidemenu', require('./components/Slide/index.vue')),
      meta: { requiresAuth: true }
    },
    {
      name: 'Sub-slide Menu',
      path: '/:id/submenu/:cat',
      component: Vue.component('submenu', require('./components/Slide/SubSlide.vue')),
      meta: { requiresAuth: true }
    },
    {
      name: 'Visita Virtual',
      path: '/:id/panorama',
      component: Vue.component('panorama', require('./components/Panorama/index.vue')),
      meta: { requiresAuth: true }
    },
    {
      name: 'Exterior',
      path: '/:id/exterior',
      component: Vue.component('exterior', require('./components/Exterior/index.vue')),
      meta: { requiresAuth: true }
    },
    {
      name: '404',
      path: '*',
      component: Vue.component('not-found', require('./components/NotFound.vue')),
      meta: { requiresAuth: true }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js